import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Text, TouchableWithoutFeedback, View } from "react-native";
import { faCheckSquare, faSquare } from "@fortawesome/pro-light-svg-icons";
import { styledRN } from "./styled";
import { useFontAwesomeIcon } from "./platform";
import { MouseInteraction } from "./animation";
import { useTheme } from "./theme";
const CheckboxInputContainer = styledRN(View, ({ $theme }) => ({
    flexShrink: 0,
    whiteSpace: 'nowrap',
    backgroundColor: $theme.midground1,
    borderRadius: 10,
    paddingRight: 12.5,
    paddingLeft: 12.5,
    cursor: 'pointer',
    userSelect: 'none'
}));
const CheckboxInputInner = styledRN(View, ({ $theme }) => ({
    height: 40,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
}));
const Label = styledRN(Text, ({ $theme }) => ({
    fontSize: 15,
    fontFamily: 'hiyllo',
    color: $theme.foreground,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5
}));
export const CheckboxInput = React.memo(function CheckboxInput(props) {
    const $theme = useTheme();
    const onPress = React.useCallback(() => {
        props.onChange(!props.value);
    }, [props]);
    const FontAwesomeIcon = useFontAwesomeIcon();
    return (_jsx(TouchableWithoutFeedback, { onPress: onPress, children: _jsx(CheckboxInputContainer, { children: _jsx(MouseInteraction, { children: _jsxs(CheckboxInputInner, { children: [_jsx(FontAwesomeIcon, { icon: props.value === true ? faCheckSquare : faSquare, color: $theme.foreground }), _jsx(Label, { children: props.label })] }) }) }) }));
});
